export default "__VITE_ASSET__9ece89ce__"